module.exports = __webpack_public_path__ + "static/img/u29.0429a28e.webp";